module.exports = "<div class=\"card\" [ngClass]=\"{'is-collapsed': collapsed, 'active': !collapsed}\">\n  <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/typescripts/pro/accordion/components/sb-item.html
// module id = ./src/app/typescripts/pro/accordion/components/sb-item.html
// module chunks = main